// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__cdc58","choiceBoxes":"toolbarselects_choiceBoxes__QVxhL","simpleField":"toolbarselects_simpleField__2wKEU"};